module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/persional-protection-phone.6ef80e52.png";